import * as React from 'react';
import DatePicker, { registerLocale } from 'react-datepicker'
import "react-datepicker/dist/react-datepicker.css";
import ja from "date-fns/locale/ja"; 
var jaLocale = {
    ...ja,
    options: {
      weekStartsOn: 0 , firstWeekContainsDate: 1
    }
}
registerLocale('ja', jaLocale);

const DateRangeInlineInput = props => {
  function handleDateChangeRaw(e) {
    e.preventDefault();
  }

  return (
    <div className="col-md-12 col-sm-12 date-range-group" style={{ padding: '0px' }}>
      <div style={props.labelStyle} className={null != props.labelColName ? props.labelColName : "col-md-4 col-sm-4 input-group-text"}>
        <label className="text">{props.label}</label>
      </div>
      <div style={props.minStyle} className={null != props.inputColName ? props.inputColName : "col-md-4 col-sm-4"}>
        <DatePicker
          className="form-control"
          dateFormat="yyyy/MM/dd"
          selected={props.minDate}
          onChange={props.onChangeMinDate.bind(this)}
          locale={jaLocale}
          dropdownMode="select"
        />
      </div>
      <label className="date-range-separator">～</label>
      <div style={props.maxStyle} className={null != props.inputColName ? props.inputColName : "col-md-4 col-sm-4"}>
        <DatePicker
          className="form-control"
          dateFormat="yyyy/MM/dd"
          selected={props.maxDate}
          onChange={props.onChangeMaxDate.bind(this)}
          locale={jaLocale}
          dropdownMode="select"
          popperPlacement={props.popperPlacementMaxDate != null ? props.popperPlacementMaxDate : "top-start"}
          disabled={props.disableTo!=null?props.disableTo:false}
        />
        {
          null == props.maxMessage || "" == props.maxMessage ? null
          :
          <div>
            <label style={{whiteSpace:"nowrap", maxWidth:"20px"}}>{props.maxMessage}</label>
          </div>
        }
      </div>
    </div>
  );
}

export default DateRangeInlineInput;


// WEBPACK FOOTER //
// ./components/forms/range/daterange.jsx